  (function () {
    if (customElements.get('ptmd-table-options')) return;

    function formatMoney(cents, format) {
      var amount = (cents / 100).toFixed(2);
      var parts = amount.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var noZeros = parts[1] === '00' ? whole : whole + '.' + parts[1];
      return (format || '${{amount}}')
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
        .replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1])
        .replace(/\{\{\s*[a-z_]+\s*\}\}/, noZeros);
    }

    class PtmdTableOptions extends HTMLElement {
      connectedCallback() {
        this.cloth = null;
        this.install = null;
        this.prices = JSON.parse(this.querySelector('[data-variant-prices]').textContent || '{}');
        this.form = document.getElementById(this.dataset.formId);
        this.requiresInstall = this.dataset.requiresInstall === 'true';
        this.needsCloth = this.dataset.needsCloth !== 'false';

        this.querySelectorAll('.ptmd-swatch').forEach((btn) => {
          btn.addEventListener('click', () => this.pickCloth(btn));
        });
        this.querySelectorAll('[data-install-choice]').forEach((r) => {
          r.addEventListener('change', () => { this.install = r.value; this.clearError(); this.update(); });
        });

        this.kit = null;
        this.querySelectorAll('[data-kit-choice]').forEach((r) => {
          if (r.checked) this.kit = r;
          r.addEventListener('change', () => { if (r.checked) { this.kit = r; this.update(); } });
        });

        this.onSubmit = this.onSubmit.bind(this);
        window.addEventListener('submit', this.onSubmit, true);
        this.onClick = this.onClick.bind(this);
        window.addEventListener('click', this.onClick, true);

        this.lastVariant = this.variantId();
        this.poll = setInterval(() => {
          var v = this.variantId();
          if (v !== this.lastVariant) { this.lastVariant = v; this.update(); }
        }, 400);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('submit', this.onSubmit, true);
        window.removeEventListener('click', this.onClick, true);
        clearInterval(this.poll);
      }

      variantId() {
        this.form = this.form || document.getElementById(this.dataset.formId);
        var input = this.form && this.form.querySelector('input[name="id"]');
        return input ? String(input.value) : '';
      }

      pickCloth(btn) {
        this.querySelectorAll('.ptmd-swatch').forEach((b) => b.setAttribute('aria-pressed', 'false'));
        btn.setAttribute('aria-pressed', 'true');
        this.cloth = { name: btn.dataset.name, code: btn.dataset.code, cent: btn.dataset.cent === 'true' };
        this.querySelector('[data-cloth-label]').textContent = this.cloth.name + (this.cloth.cent ? ' (+' + this.money(Number(this.dataset.centPrice)) + ')' : '');
        this.clearError();
        this.update();
      }

      money(cents) { return formatMoney(cents, this.dataset.moneyFormat); }

      update() {
        var table = this.prices[this.variantId()] || 0;
        var cent = this.cloth && this.cloth.cent ? Number(this.dataset.centPrice) : 0;
        var inst = this.install === 'pro' ? Number(this.dataset.installPrice) : 0;
        this.querySelector('[data-sum-table]').textContent = this.money(table);
        var centRow = this.querySelector('[data-sum-cent-row]');
        if (centRow) { centRow.hidden = !cent; this.querySelector('[data-sum-cent]').textContent = '+' + this.money(cent); }
        this.querySelector('[data-sum-install-row]').hidden = !inst;
        this.querySelector('[data-sum-install]').textContent = '+' + this.money(inst);
        var kitPrice = this.kit && this.kit.value ? Number(this.kit.dataset.kitPrice) : 0;
        var kitRow = this.querySelector('[data-sum-kit-row]');
        if (kitRow) {
          kitRow.hidden = !(this.kit && this.kit.value);
          this.querySelector('[data-sum-kit-name]').textContent = this.kit ? this.kit.dataset.kitName : '';
          this.querySelector('[data-sum-kit]').textContent = kitPrice ? '+' + this.money(kitPrice) : 'Free';
        }
        this.querySelector('[data-sum-total]').textContent = this.money(table + cent + inst + kitPrice);
      }

      showError(msg) {
        var el = this.querySelector('[data-error]');
        el.textContent = msg; el.hidden = false;
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      clearError() { var el = this.querySelector('[data-error]'); el.hidden = true; el.textContent = ''; }

      missing() {
        if (this.needsCloth && !this.cloth) return 'Please choose a cloth color.';
        if (this.requiresInstall && !this.install) return 'Please choose Professional installation or No installation.';
        return '';
      }

      // Stop the theme's "added" animation from playing when a choice is still missing.
      onClick(event) {
        this.form = this.form || document.getElementById(this.dataset.formId);
        var btn = event.target.closest && event.target.closest('button[type="submit"]');
        if (!btn || !this.form || btn.form !== this.form) return;
        var msg = this.missing();
        if (msg) { event.preventDefault(); event.stopImmediatePropagation(); this.showError(msg); }
      }

      onSubmit(event) {
        this.form = this.form || document.getElementById(this.dataset.formId);
        if (!this.form || event.target !== this.form) return;

        if (this.needsCloth && !this.cloth) {
          event.preventDefault(); event.stopImmediatePropagation();
          this.showError('Please choose a cloth color.');
          return;
        }
        if (this.requiresInstall && !this.install) {
          event.preventDefault(); event.stopImmediatePropagation();
          this.showError('Please choose Professional installation or No installation.');
          return;
        }

        event.preventDefault(); event.stopImmediatePropagation();

        var props = this.cloth ? { 'Cloth Color': this.cloth.name, '_Cloth Code': this.cloth.code } : {};
        if (this.requiresInstall) props['Installation'] = this.install === 'pro' ? 'Professional installation' : 'No installation (buyer arranges)';

        var qtyInput = this.form.querySelector('input[name="quantity"]') || document.querySelector('input[name="quantity"][form="' + this.dataset.formId + '"]');
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        var items = [];
        if (this.cloth && this.cloth.cent && this.dataset.centId) {
          items.push({ id: Number(this.dataset.centId), quantity: qty, properties: { 'For': this.dataset.productTitle, 'Cloth Color': this.cloth.name } });
        }
        if (this.kit && this.kit.value) {
          items.push({ id: Number(this.kit.value), quantity: qty, properties: { 'For': this.dataset.productTitle } });
          props['Accessory Kit'] = this.kit.dataset.kitName;
        }
        if (this.install === 'pro' && this.dataset.installId) {
          items.push({ id: Number(this.dataset.installId), quantity: qty, properties: { 'For': this.dataset.productTitle } });
        }
        // The cart lists the newest line first, so the table goes last to show on top.
        items.push({ id: Number(this.variantId()), quantity: qty, properties: props });

        var buttons = this.form.querySelectorAll('button[type="submit"]');
        buttons.forEach((b) => (b.disabled = true));
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then((r) => r.json().then((j) => ({ ok: r.ok, j: j })))
          .then((res) => {
            if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || 'Could not add to cart.');
            window.location.href = root + 'cart';
          })
          .catch((err) => {
            buttons.forEach((b) => (b.disabled = false));
            this.showError(err.message + ' Please try again or text (305) 915-4398.');
          });
      }
    }

    customElements.define('ptmd-table-options', PtmdTableOptions);
  })();